<!-- <footer class="footer">
    <div class="container">
    <div class="row">
        <div class="col-lg-3">
           <div class="ftr-logo">
                <a routerLink="/" class="inline-block">
                    <img src="assets/images/logo-1.png" alt="logo" class="logo-img" >
                </a>
           </div>
        </div>
        <div class="col-lg-3">
            <h4>About</h4>
            <p>
                With customizable dashboards tailored to your needs, collaborate effortlessly with your team and stay ahead with real-time updates.
            </p>
        </div>
        <div class="col-lg-3">
            <div class="ftr-li">
                <h4>Quick Links</h4>
                <ul>
                    <li><a href="#">Home</a></li>
                    <li><a href="#">Features</a></li>
                    <li><a href="#">Our Team</a></li>
                    <li><a href="#">Contact</a></li>
                </ul>
            </div>
        </div>
        <div class="col-lg-3">
            <h4>Privacy Policy</h4>
            <ul>
                <li><a href="#">Terms & Conditions</a></li>
                <li><a href="#">Cookie Policy</a></li>
                <li><a href="#">Notice at Collection</a></li>
                <li><a href="#">Privacy Policy</a></li>
            </ul>
        </div>
    </div>
    </div>
</footer> -->



<div class="footer-sec">
    <p class="text-center text-gray-500 text-sm m-0">
        Developed by Webel Technology Limited.
    </p>
</div>